import { useIntl } from 'react-intl';

import { FormattedDateWrapper } from './styles';

type FormattedDateProps = {
  date: string;
  timeZone: string;
};

export const FormattedDate = ({ date, timeZone }: FormattedDateProps) => {
  const intl = useIntl();

  return (
    <FormattedDateWrapper>
      {intl.formatDate(date, {
        timeZone,
        month: 'short',
        day: 'numeric',
        weekday: 'short',
      })}
    </FormattedDateWrapper>
  );
};
